import React from "react"
import {
  FormControl,
  ControlLabel,
  Modal,
  Button,
  FormGroup,
  Row,
  Col,
  ButtonToolbar,
  ToggleButtonGroup,
  ToggleButton,
} from "react-bootstrap"
import FieldGroup from "../../fragments/FieldGroup"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { customerImageType, validateTextState } from "../../../lib/utils"

const customerImageTypeList = Object.values(customerImageType).sort()

export default class AddCustomerDocumentModal extends React.Component {

  state = {
    label: '',
    mandatory: false,
    imageType: '',
    error: null,
    labelValidationState: null,
    imageTypeValidationState: null,
  }

  clearInputs = () => this.setState({
    label: '',
    mandatory: false,
    imageType: '',
    error: null,
    labelValidationState: null,
    imageTypeValidationState: null,
  })

  imageTypeChanged = imageType => this.setState({
    imageType,
    imageTypeValidationState: validateTextState(imageType, false),
    error: null,
  })

  labelChanged = label => this.setState({
    label,
    labelValidationState: validateTextState(label, false),
    error: null,
  })

  mandatoryChanged = value => this.setState({ mandatory: value === 'Yes' ? true : false })

  valid = ({ imageType, label }) => validateTextState(imageType, false) === 'success' 
    && validateTextState(label, false) === 'success'

  saveField = () => {

    this.setState({ error: null })
    const data = { 
      imageType: this.state.imageType, 
      label: this.state.label,
      mandatory: this.state.mandatory 
    }

    try {
      if(!this.valid(data)) throw new Error('Some fields are incorrect.')
      if(this.props.documentExists(data.imageType)) throw new Error(`Duplicate field: ${ data.imageType }`)
      this.props.addDocument(data)

      setTimeout(this.closeModal, 200)
    }
    catch(e) {
      this.setState({
        error: e.message,
        imageTypeValidationState: validateTextState(data.imageType, false),
        labelValidationState: validateTextState(data.label, false),
      })
    }
  }

  closeModal = () => {
    this.props.close()
    this.clearInputs()
  }

  render() {

    const { show } = this.props,
    tab = ['Yes', 'No']

    return (
      <Modal show={ show } onHide={ this.closeModal }>

        <Modal.Header closeButton>
          <Modal.Title>Add a new customer document</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Row>
            <Col xs={6}>
              <FormGroup controlId='type' validationState={ this.state.imageTypeValidationState }>
                <ControlLabel>Image type</ControlLabel>
                <FormControl componentClass="select" placeholder="select"
                  value={ this.state.imageType }
                  onChange={e => this.imageTypeChanged(e.target.value)}>
                  <option value=""></option>
                  { customerImageTypeList.map(item => <option key={ item } value={ item }>{ item }</option>) }
                </FormControl>
              </FormGroup>
            </Col>

            <Col xs={6}>
              <FormGroup controlId='mandatory' validationState='success'>
                <ControlLabel>Mandatory</ControlLabel>
                <ButtonToolbar>
                  <ToggleButtonGroup
                    onChange={ this.mandatoryChanged }
                    type="radio"
                    name="mandatory"
                    defaultValue={ this.state.mandatory ? 'Yes' : 'No' }>
                    { tab.map((value, index) => (
                      <ToggleButton key={ index } value={ value }>{ value }</ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </ButtonToolbar>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={6}>
              <FieldGroup
                id="label"
                type="text"
                label="Label"
                placeholder="Ex: ID Card"
                validationState={ this.state.labelValidationState }
                value={ this.state.label }
                onChange={e => this.labelChanged(e.target.value)}
                maxLength={32}
                autoFocus
              />
            </Col>
            <Col xs={6}></Col>
          </Row>

          <ProcessesStatus error={ this.state.error } />

        </Modal.Body>

        <Modal.Footer>
          <Button onClick={ this.closeModal }>Close</Button>
          <Button onClick={ this.saveField } bsStyle="primary">Add</Button>
        </Modal.Footer>

      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/Customers/AddCustomerDocumentModal.js